// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-cancelled-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px 0;
  height: 70%;
}

.warning-icon {
  font-size: 48px;
  height: 48px;
  width: 48px;
  color: var(--ion-color-warning);
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}

p {
  font-size: 16px;
  line-height: 1.5;
  color: var(--ion-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/payment-cancelled-modal/payment-cancelled-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AACD;;AAEA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,mBAAA;AACD;;AAEA;EACC,aAAA;EACA,QAAA;EACA,gBAAA;AACD;;AAEA;EACC,eAAA;EACA,gBAAA;EACA,4BAAA;AACD","sourcesContent":[".payment-cancelled-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\tpadding: 20px 0;\n\theight: 70%;\n}\n\n.warning-icon {\n\tfont-size: 48px;\n\theight: 48px;\n\twidth: 48px;\n\tcolor: var(--ion-color-warning);\n\tmargin-bottom: 16px;\n}\n\n.action-buttons {\n\tdisplay: flex;\n\tgap: 8px;\n\tmargin-top: 24px;\n}\n\np {\n\tfont-size: 16px;\n\tline-height: 1.5;\n\tcolor: var(--ion-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
